import './support/debug/sentry.ts'; // do this first so we catch all errors
import { createRoot } from 'react-dom/client';
import { TextZoom } from '@capacitor/text-zoom';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { Device } from '@capacitor/device';
import { AutoPylotApp } from './app/AutoPylotApp.tsx';

Device.getInfo().then(({ platform }) => {
    if (platform === 'android'){
        // don't let android text zoom change our font size
        TextZoom.set({ value:  1.0 });

        // Lock portrait orientation on android if smaller screen dimension is too small
        if (Math.min(window.innerHeight, window.innerWidth) < 600) {
            ScreenOrientation.lock({ orientation: 'portrait' });
        }
    }
});

// set the sha on window, so it is part of the deployed app, and can be scraped by screenshots
(window as any).AP_APP_SHA = process.env.VITE_APP_SHA;

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
    <AutoPylotApp />
);
